<template>
    <div>
        <div class="user-avatar">
            <img :src="profilePhoto" alt="" :width="width">

            <div v-if="edit" class="mt-2">                
                <b-alert variant="danger" :show="showError" class="mb-3">
                    <ul class="mb-0">
                        <li v-for="(error, prop) in errors" :key="prop">
                            {{ error[0] }}
                        </li>
                    </ul>
                </b-alert>
                
                <b-form-file
                    v-model="uploadImg"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    accept=".jpg, .png, .gif"
                    ></b-form-file>
                <small class="form-text text-muted">
                    .jpg or .png only.  Under 2MB.
                </small>
                <button type="button" class="btn btn-success" @click="upload" :disabled="isBusy">{{ btnText }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            edit: {
                type: Boolean,
                required: false,
            },
            width: {
                type: Number,
                required: false,
                default: 256,
            },
        },

        data() {
            let photoImg = window.virtuoso.user.profilePhotoUrlLarge;

            return {
                profilePhoto: photoImg,
                uploadImg: null,
                isBusy: false,
                showError: false,
                errors: '',
                btnText: 'Upload and Save',
            }
        },

        mounted() {
        },

        methods: {
            // Upload
            upload() {
                this.isBusy = true;
                this.errors = null;
                this.showError = false;
                this.btnText = 'Please wait...';

                var formData = new FormData();
                formData.append("image", this.uploadImg);

                axios.post('/api/me/upload-photo', formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((response) => {
                    this.profilePhoto = response.data.profilePhotoUrlLarge;
                    this.reset();

                    Bus.$emit('avatarUpdated', {
                        'profilePhoto': this.profilePhoto,
                    });
                }).catch((e) => {
                    this.showError = true;
                    this.errors = e.response.data.errors;
                    this.reset();
                });
            },

            // Reset form
            reset() {
                this.isBusy = false;
                this.btnText = 'Upload and Save';
            },
        }
    }
</script>